(function () {
  'use strict';

  var utilitySection = document.querySelector('.marla-utility-bar-section');
  var headerSection  = document.querySelector('.header-section');
  if (!utilitySection || !headerSection) return;

  // Wrap both sections in a single sticky chrome element so the utility bar
  // and nav move as one unit, allowing transform to slide the bar away while
  // keeping the nav pinned at the viewport top.
  var chrome = document.createElement('div');
  chrome.className = 'marla-chrome';
  utilitySection.parentNode.insertBefore(chrome, utilitySection);
  chrome.appendChild(utilitySection);
  chrome.appendChild(headerSection);

  // Keep --marla-utility-h in sync so the translate amount is always accurate.
  function measure() {
    var h = utilitySection.offsetHeight;
    if (h) chrome.style.setProperty('--marla-utility-h', h + 'px');
    measureChromeH();
  }

  // Track the effective sticky height of the chrome so the subnav can stick
  // just below it. When the utility bar is hidden we subtract its height;
  // when it's visible we use the full chrome height. Computed pre-transition
  // so the subnav jumps straight to its final position without lag.
  function measureChromeH() {
    var utilH  = utilitySection.offsetHeight || 0;
    var totalH = chrome.offsetHeight || 0;
    var effective = chrome.hasAttribute('data-utility-hidden')
      ? (totalH - utilH)
      : totalH;
    document.documentElement.style.setProperty('--marla-chrome-h', effective + 'px');
  }

  measure();
  window.addEventListener('resize', measure, { passive: true });

  var lastY     = window.scrollY;
  var threshold = 6;    // px — ignore micro-jitter
  var hideAfter = 80;   // px — don't hide until we're clear of the bar itself
  var ticking   = false;

  function update() {
    var y  = window.scrollY;
    var dy = y - lastY;

    if (y <= 4) {
      // At the very top — always show the utility bar.
      chrome.removeAttribute('data-utility-hidden');
      measureChromeH();
    } else if (dy > threshold && y > hideAfter) {
      // Scrolling down far enough — slide bar away.
      chrome.setAttribute('data-utility-hidden', 'true');
      measureChromeH();
    } else if (dy < -threshold) {
      // Any upward scroll — bring bar back immediately.
      chrome.removeAttribute('data-utility-hidden');
      measureChromeH();
    }

    lastY   = y;
    ticking = false;
  }

  window.addEventListener('scroll', function () {
    if (!ticking) {
      window.requestAnimationFrame(update);
      ticking = true;
    }
  }, { passive: true });

  // Smooth scroll for the Curator's Edit anchor link
  var curatorsLink = document.querySelector('.marla-utility-bar__curators');
  if (curatorsLink) {
    curatorsLink.addEventListener('click', function (e) {
      var target = document.getElementById('curators-edit');
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  }
})();
